import { Controller } from "@hotwired/stimulus"
import { getCloudFrontKeyPairId } from "../vendor/cloudfront-utils.js"

// Connects to data-controller="review-image-loader"
// Loads CloudFront images for review pages (practice passages, games, etc.)
export default class extends Controller {
  static values = {
    itemUrl: String,
    policy: String,
    signature: String,
    extractMethod: { type: String, default: "slice" }, // "slice" or "split"
    cdnPath: { type: String, default: "Questions" }, // CDN subdirectory (Questions, question-images, etc.)
    setDimensions: { type: Boolean, default: true } // Whether to set image dimensions on load
  }

  get keyPairId() {
    return getCloudFrontKeyPairId()
  }

  connect() {
    this.loadImage()
  }

  loadImage() {
    if (!this.hasItemUrlValue) return

    // Extract item ID based on method:
    // "slice": slice first 3 chars, remove .png (e.g., "Q/x123.png" -> "123")
    // "split": split by /, take second part, remove .png (e.g., "Games/G123.png" -> "G123")
    let item
    if (this.extractMethodValue === "split") {
      item = this.itemUrlValue.replace(".png", "").split('/')[1]
    } else {
      item = this.itemUrlValue.slice(3).replace(".png", "")
    }

    const cover = document.getElementById(item)
    const target = document.getElementById(item + "-alt")

    if (!target) {
      console.warn(`[review-image-loader] Could not find target element for item: ${item}`)
      return
    }

    // Build CloudFront signed URL
    const imageUrl = `https://cdn.lsatengine.com/${this.cdnPathValue}/${this.itemUrlValue}?Policy=${this.policyValue}&Signature=${this.signatureValue}&Key-Pair-Id=${this.keyPairId}`
    target.src = imageUrl

    // Optionally set dimensions when image loads
    if (this.setDimensionsValue && cover) {
      target.onload = () => {
        const newWidth = target.naturalWidth / 2
        const newHeight = target.naturalHeight / 2
        const imgWrap = document.getElementById('img-wrap-' + item)

        if (imgWrap) {
          imgWrap.style.width = `${newWidth}px`
        }

        target.style.width = `${newWidth}px`
        cover.style.width = `${newWidth}px`
        cover.style.height = `${newHeight}px`
      }
    }
  }
}
